export enum SharedPersistentStateEnum {
  table = 'table',
  grid = 'grid'
}
